<template>
  <CardSection sectionCaption="Conversations">
    <template #content>
      <PvDataTable :value="conversations"
                   :size="'small'"
                   :paginator="conversations && conversations.length > 10"
                   :rows="10"
                   scrollable
                   sortField="lastMessageDate"
                   :sortOrder="-1">
        <PvColumn v-for="col of columns" 
                  :key="col.field" 
                  :field="col.field"
                  :header="col.header"
                  :style="{ width: col.width || 'auto' }">
          <template v-if="col.bodySlot === 'actions'" #body="slotProps">
            <div class="d-flex gap-2">
              <PvButton size="small"
                        :icon="ICONS.View"
                        type="button"
                        label="View"
                        class="button-w-100"
                        title="View Conversation"
                        :aria-label="`View ${slotProps.data.conversationSubject} Conversation`"
                        severity="primary"
                        rounded outlined
                        @click="handleViewConversation(slotProps.data)" />
            </div>
          </template>
          <template v-else-if="col.bodySlot === 'subject'" #body="slotProps">
            <span>{{ slotProps.data.conversationSubject }}</span>
            <PvBadge v-if="!slotProps.data.isRead"
                     :value="'New'"
                     severity="success"
                     :aria-label="`New message`"
                     class="ms-3" />      
            <span v-if="!slotProps.data.isRead" class="visually-hidden">New Message</span>
          </template>
          <template v-else-if="col.bodySlot === 'date'" #body="slotProps">
            {{ formatDateTime(slotProps.data[col.field]) }}
          </template>          
        </PvColumn>
        <template #empty>
          <NoData message="No conversations to display." />
        </template>
      </PvDataTable>
      <div class="text-center mt-3">
        <PvButton v-if="conversations && conversations.length > 0"
                  label="Go To Conversations"
                  type="button"
                  :icon="ICONS.View"
                  rounded
                  @click="router.push('/conversations')" />
      </div>
    </template>
  </CardSection>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { useRouter } from 'vue-router';

// Components
import CardSection from '../common/CardSection.vue';
import NoData from '@/components/common/NoData.vue';

// Composables


// Stores
import { useConversationStore } from '@/stores/ConversationStore';

// Constants and Utils
import { ICONS } from '@/utils/constants';
import { formatDateTime } from '@/utils/dataUtils';


// ===============================
// PROPS & EMITS
// ===============================
defineProps({
  conversations: {
    type: Array,
    required: false,
    default: null
  }
});

// ===============================
// COMPOSABLES & STORES
// ===============================
const conversationStore = useConversationStore();
const router = useRouter();

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================
const columns = [
  { header: 'Actions', bodySlot: 'actions', width: '110px' },
  { field: 'conversationSubject', header: 'Subject', bodySlot: 'subject' },
  { field: 'lastMessageDate', header: 'Last Message Date', bodySlot: 'date', width: '200px' },
  { field: 'lastMessageUser', header: 'Last Message From', width: '300px' },
  { field: 'createDate', header: 'Create Date', bodySlot: 'date', width: '200px' },
  { field: 'createUser', header: 'Created By', width: '300px' },
];

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================
const handleViewConversation = async (conversation) => {
  if (conversation.conversationId) {
    // Set active conversation in store
    conversationStore.setActiveConversationParameters(conversation.conversationId, conversation.threadId);
    // Mark as read if unread
    if (!conversation.isRead) {
      await conversationStore.markAsRead(conversation.conversationId);
    }

    // Navigate to conversation detail page
    router.push(`/conversations/conversation`);
  }
};

// ===============================
// LIFECYCLE HOOKS
// ===============================

</script>
